var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Rdretailicons6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.99 20.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20.99,
    height: 20.99,
    rx: 1.5,
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.58,
    r: 7.89,
    style: {
      fill: "#1e3f76",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.71,8.74h-7a1,1,0,0,0-1,1v7h.67v-3h7.34l-1.9-2.52Z",
    transform: "translate(-2.04 -1.92)",
    style: {
      fill: "#171c32"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Rdretailicons6);
export default __webpack_public_path__ + "static/media/3rdretailicons6.6f7bfbb94e3ad5ac7581546cb653c8b0.svg";
export { ForwardRef as ReactComponent };